import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvForm, AvGroup} from 'availity-reactstrap-validation';
import Translate from '../../shared/language/Translate';
import GeneralUtils from '../../shared/utils/GeneralUtils';
import AvField from '../../shared/component/form/AvField';
import FormSection from '../../shared/component/form/FormSection';
import PurchaseRequisitionService from '../../shared/service/PurchaseRequisitionService';
import SupplierService from '../../shared/service/SupplierService';
import LicenseService from '../../shared/service/LicenseService';
import PurchaseRequisitionItemColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionItemColumn.json';
import PurchaseRequisitionAssignPoColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionAssignPoColumn.json';
import PurchaseRequisitionAssignDnColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionAssignDnColumn.json';
import PurchaseRequisitionDeliveryCompareColumn from '../../shared/component/dataTable/columns/PurchaseRequisitionDeliveryCompareColumn.json';
import Dialog from '../../shared/component/dialog/Dialog';
import Loading from '../../shared/component/others/Loading';
import ModalConfirm from '../../shared/component/dialog/ModalConfirm';
import PurchaseRequisitionItemMobileSave from '../purchaserequisitionmobile/PurchaseRequisitionItemMobileSave';
import PurchaseRequisitionItemDataTable from './PurchaseRequisitionItemDataTable';
import DataTable from '../../shared/component/dataTable/DataTable';
import SupplierFilter from '../storemanagement/SupplierFilter';
import {applyCostWarningsToItems, buildCheckoutPayload, buildDeliveryItemsFromPurchaseOrder, buildDeliveryPoComparisonRows, buildReturnItemsFromDeliveryNote, countDeliveryPoComparisonIssues, ensureMerchantBranchNamesLoaded, exportBulkSupplierPdf, exportSupplierPdf, formatCheckoutValidationErrors, formatSupplierTotalCost, getLoggedInUserEmail, getRequisitionDocLabels, getSupplierGroupTotalCost, getSupplierMailDetails, groupItemsBySupplier, hasUnknownSupplierItems, isDuplicateBarcodeInList, isReturnItemsLockedFromDeliveryNote, normalizeItem, normalizeRequisition, persistRequisitionToDb, removeItemFromList, shouldOfferCreateReturn, upsertRequisitionItem, validateItemsForCheckout, validateCheckoutEmailOptions, buildInitialCheckoutOptions, wasSupplierEmailSent} from './PurchaseRequisitionUtils';
import {getPurchaseRequisitionListReturnHash} from './PurchaseRequisitionListNav';
import PurchaseRequisitionNavShortcuts, {shortcutIdForRequisitionStatus} from './PurchaseRequisitionNavShortcuts';
import {Checkbox} from 'primereact/checkbox';
import dayjs from 'dayjs';
import {toast} from 'react-toastify';
import {PURCHASE_REQUISITION_STATUS, RETURN_REASON_CODE, DELIVERY_WASTE_REASON_CODE} from '../../shared/utils/Constants';
import {
    deriveOrderBoxCount
} from './PurchaseRequisitionActualOrderUtils';
import '../../shared/styles/SettingsPage.css';

const LICENSE_REQUIRED_MESSAGE = "You don't have an invoice license.";

const defaultRequisition = {
    id: null,
    description: '',
    requisitionStatus: 'OPEN',
    approved: false,
    approvedDate: null,
    createDate: null,
    supplierId: null,
    supplierName: null,
    supplierBssId: null,
    itemList: []
};

const defaultItem = {
    id: null,
    barcode: null,
    itemName: null,
    itemBssId: null,
    itemUnitMeasure: null,
    itemSize: null,
    boxSize: null,
    deliveredBoxCount: null,
    orderUnitOfMeasure: 'SINGLE',
    supplierId: null,
    supplierName: null,
    supplierBssId: null,
    currentCost: null,
    minStock: null,
    maxStock: null,
    recommendedOrderAmount: null,
    actualOrderAmount: null,
    damagedQuantity: null,
    expiryDate: null,
    currentStock: null,
    status: 'ACTIVE'
};

export default class PurchaseRequisitionSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hasInvoiceLicense: false,
            requisition: Object.assign({}, defaultRequisition),
            loading: false,
            displayDialog: false,
            displayDeleteConfirmDialog: false,
            displayRemoveItemConfirmDialog: false,
            itemToRemove: null,
            displayCheckoutDialog: false,
            checkoutOptions: {},
            displayCheckoutConfirmDialog: false,
            displayApproveConfirmDialog: false,
            approveOfferCreateReturn: false,
            displayCreateReturnConfirmDialog: false,
            displayAssignPurchaseOrderDialog: false,
            displayAssignDeliveryNoteDialog: false,
            selectedPurchaseOrderId: null,
            selectedDeliveryNoteId: null,
            checkoutDialogMode: null,
            assignedPurchaseOrder: null,
            comparisonRows: [],
            comparisonVersion: 0,
            loggedInUserEmail: getLoggedInUserEmail(),
            displaySupplierFilterDialog: false
        };
        this.purchaseRequisitionService = new PurchaseRequisitionService();
        this.supplierService = new SupplierService();
        this.licenseService = new LicenseService();
    }

    componentDidMount() {
        if (GeneralUtils.isMobile()) {
            window.location.href = '#inventoryManagementMobile';
            return;
        }
        this.checkInvoiceLicense();
        window.addEventListener('hashchange', this.onDocumentHashChange);
    }

    checkInvoiceLicense = () => {
        this.licenseService.getLicenses(localStorage.getItem('merchantBranchId')).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                && response.hasInvoiceLicense === true) {
                this.setState({hasInvoiceLicense: true}, () => {
                    ensureMerchantBranchNamesLoaded();
                    const id = this.getRequisitionIdFromUrl();
                    if (!GeneralUtils.__isValueEmpty(id) && id !== '-1') {
                        this.loadRequisition(id);
                    } else {
                        this.initNewRequisition();
                    }
                });
            } else {
                toast.warn(LICENSE_REQUIRED_MESSAGE);
                window.location.href = getPurchaseRequisitionListReturnHash();
            }
        });
    };

    componentWillUnmount() {
        window.removeEventListener('hashchange', this.onDocumentHashChange);
    }

    onDocumentHashChange = () => {
        if (!window.location.href.includes('purchaseRequisitionSave')) {
            return;
        }
        if (!this.state.hasInvoiceLicense) {
            return;
        }
        const id = this.getRequisitionIdFromUrl();
        const currentId = this.state.requisition?.id;
        if (!GeneralUtils.__isValueEmpty(id) && id !== '-1') {
            if (String(id) !== String(currentId)) {
                this.loadRequisition(id);
            }
            return;
        }
        if (currentId) {
            this.initNewRequisition();
        }
    };

    getRequisitionIdFromUrl = () => {
        const href = window.location.href;
        const query = href.split('?')[1];
        if (GeneralUtils.__isValueEmpty(query)) {
            return null;
        }
        let idPart = query.split('&')[0].replace(/^=/, '');
        if (!idPart || idPart.indexOf('mode=') === 0) {
            return null;
        }
        if (idPart !== '-1') {
            return idPart;
        }
        return null;
    };

    goBackToList = () => {
        window.location.href = getPurchaseRequisitionListReturnHash();
    };

    isDeliveryModeFromUrl = () => {
        const href = window.location.href;
        const query = href.split('?')[1] || '';
        return query.includes('mode=delivery');
    };

    isReturnModeFromUrl = () => {
        const href = window.location.href;
        const query = href.split('?')[1] || '';
        return query.includes('mode=return');
    };

    isDeliveryNote = () => this.state.requisition?.requisitionStatus === 'DELIVERY_NOTE';

    isReturnNote = () => this.state.requisition?.requisitionStatus === 'RETURN';

    isPurchaseOrder = () => this.state.requisition?.requisitionStatus === 'PURCHASE_ORDER';

    openLinkedDocument = (id) => {
        if (GeneralUtils.isNullOrEmpty(id)) {
            return;
        }
        window.location.href = '#/purchaseRequisitionSave?' + id;
    };

    openLinkedInvoice = (invoiceId) => {
        if (GeneralUtils.isNullOrEmpty(invoiceId)) {
            return;
        }
        window.location.href = '#/purchaseOrderSave?' + invoiceId;
    };

    isApproved = () => {
        const approved = this.state.requisition?.approved;
        return approved === true || approved === 'true' || approved === 1 || approved === '1';
    };

    initNewRequisition = () => {
        let requisitionStatus = 'OPEN';
        if (this.isDeliveryModeFromUrl()) {
            requisitionStatus = 'DELIVERY_NOTE';
        } else if (this.isReturnModeFromUrl()) {
            requisitionStatus = 'RETURN';
        }
        this.setState({
            requisition: {
                ...defaultRequisition,
                requisitionStatus,
                createDate: dayjs().format('DD/MM/YYYY'),
                itemList: []
            }
        });
    };

    loadRequisition = (id) => {
        this.setState({loading: true});
        this.purchaseRequisitionService.findById(id).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.applyCostWarnings(normalizeRequisition(response)).then(requisition => {
                    this.setState({requisition, loading: false}, () => {
                        this.loadAssignedPurchaseOrder(requisition.assignedPurchaseRequisitionId);
                    });
                });
            } else {
                this.setState({loading: false});
            }
        }).catch(() => this.setState({loading: false}));
    };

    loadAssignedPurchaseOrder = (purchaseOrderId) => {
        if (GeneralUtils.isNullOrEmpty(purchaseOrderId)) {
            this.setState(prev => ({
                assignedPurchaseOrder: null,
                comparisonRows: [],
                comparisonVersion: (prev.comparisonVersion || 0) + 1
            }));
            return Promise.resolve(null);
        }
        return this.purchaseRequisitionService.findById(purchaseOrderId).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState(prev => ({
                    assignedPurchaseOrder: null,
                    comparisonRows: [],
                    comparisonVersion: (prev.comparisonVersion || 0) + 1
                }));
                return null;
            }
            const assignedPurchaseOrder = normalizeRequisition(response);
            const dnItems = this.state.requisition.itemList || [];
            const comparisonRows = buildDeliveryPoComparisonRows(
                assignedPurchaseOrder.itemList,
                dnItems
            );
            this.setState(prev => ({
                assignedPurchaseOrder,
                comparisonRows,
                comparisonVersion: (prev.comparisonVersion || 0) + 1
            }));
            return assignedPurchaseOrder;
        }).catch(() => {
            this.setState(prev => ({
                assignedPurchaseOrder: null,
                comparisonRows: [],
                comparisonVersion: (prev.comparisonVersion || 0) + 1
            }));
            return null;
        });
    };

    /**
     * First-time PO select: fill DN lines so delivered qty = ordered qty.
     */
    seedDeliveryItemsFromPurchaseOrderIfEmpty = (purchaseOrder) => {
        if (!this.isDeliveryNote() || !this.isEditable()) {
            return Promise.resolve(null);
        }
        const existing = this.state.requisition?.itemList || [];
        if (existing.length > 0) {
            return Promise.resolve(null);
        }
        if (!purchaseOrder?.itemList?.length) {
            return Promise.resolve(null);
        }
        const seeded = buildDeliveryItemsFromPurchaseOrder(purchaseOrder.itemList, {
            supplierId: this.state.requisition.supplierId,
            supplierName: this.state.requisition.supplierName,
            supplierBssId: this.state.requisition.supplierBssId
        });
        if (seeded.length === 0) {
            return Promise.resolve(null);
        }
        const requisition = {...this.state.requisition, itemList: seeded};
        return this.persistSeededRequisition(requisition, seeded);
    };

    /**
     * First-time DN select on empty Return: copy all DN lines with Return Qty = 0.
     * (Create Return from DN waste is a separate backend path and keeps waste qty.)
     */
    seedReturnItemsFromDeliveryNoteIfEmpty = (deliveryNote) => {
        if (!this.isReturnNote() || !this.isEditable()) {
            return Promise.resolve(null);
        }
        const existing = this.state.requisition?.itemList || [];
        if (existing.length > 0) {
            return Promise.resolve(null);
        }
        if (!deliveryNote?.itemList?.length) {
            return Promise.resolve(null);
        }
        // Manual DN assign: copy lines with return qty 0 (user fills qty).
        // Do not use waste qty here — that is only for create-return-from-DN flow.
        let seeded = buildReturnItemsFromDeliveryNote(deliveryNote.itemList, {
            wasteOnly: false,
            useWasteAsQty: false
        });
        if (seeded.length === 0) {
            toast.warn('Selected Delivery Note has no items to return');
            return Promise.resolve(null);
        }
        const description = !GeneralUtils.isNullOrEmpty(this.state.requisition.description)
            ? this.state.requisition.description
            : (deliveryNote.requisitionNo
                ? `Return Note from ${deliveryNote.requisitionNo}`
                : 'Return Note from Delivery Note');
        const requisition = {
            ...this.state.requisition,
            description,
            itemList: seeded
        };
        return this.persistSeededRequisition(requisition, seeded, {description});
    };

    persistSeededRequisition = (requisition, seededFallback, extraFields = {}) => {
        return persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState(prev => ({
                    requisition: {...prev.requisition, ...extraFields, itemList: seededFallback}
                }), () => this.refreshComparisonRows());
                return null;
            }
            return this.applyCostWarnings(result.requisition).then(enriched => {
                this.setState({requisition: enriched}, () => this.refreshComparisonRows());
                return enriched;
            });
        });
    };

    findPoItemByBarcode = (barcode) => {
        const key = String(barcode || '').trim();
        if (!key) {
            return null;
        }
        return (this.state.assignedPurchaseOrder?.itemList || [])
            .find(item => String(item?.barcode || '').trim() === key) || null;
    };

    createDnItemFromPoOrRow = (row) => {
        const barcode = String(row?.barcode || '').trim();
        const poItem = this.findPoItemByBarcode(barcode);
        const orderedQty = Number(row?.orderedQty) || 0;
        const source = poItem || {};
        let boxSize = source.boxSize != null && String(source.boxSize).trim() !== ''
            ? Number(source.boxSize)
            : 1;
        if (!Number.isFinite(boxSize) || boxSize <= 0) {
            boxSize = 1;
        }
        const qty = orderedQty > 0 ? orderedQty : 0;
        const derivedBoxes = deriveOrderBoxCount(qty, boxSize);
        return normalizeItem({
            id: null,
            barcode,
            itemName: row?.itemName || source.itemName || null,
            longName: source.longName || row?.itemName || source.itemName || null,
            webImagePath: source.webImagePath || null,
            itemBssId: source.itemBssId || null,
            itemUnitMeasure: source.itemUnitMeasure || null,
            itemSize: source.itemSize ?? null,
            boxSize,
            deliveredBoxCount: derivedBoxes != null ? derivedBoxes : 1,
            actualOrderAmount: qty,
            recommendedOrderAmount: qty,
            damagedQuantity: 0,
            currentCost: source.currentCost ?? null,
            minStock: source.minStock ?? null,
            maxStock: source.maxStock ?? null,
            currentStock: source.currentStock ?? null,
            currentSupplierId: this.state.requisition.supplierId ?? source.currentSupplierId ?? null,
            currentSupplierName: this.state.requisition.supplierName ?? source.currentSupplierName ?? null,
            supplierBssId: this.state.requisition.supplierBssId ?? source.supplierBssId ?? null,
            status: 'ACTIVE'
        });
    };

    applyDeliveredQtyToItem = (item, deliveredQtyRaw) => {
        const raw = deliveredQtyRaw === '' || deliveredQtyRaw == null ? 0 : Number(deliveredQtyRaw);
        const deliveredQty = Number.isNaN(raw) || raw < 0 ? 0 : raw;
        let boxSize = item.boxSize != null && item.boxSize !== '' ? Number(item.boxSize) : 1;
        if (!Number.isFinite(boxSize) || boxSize <= 0) {
            boxSize = 1;
        }
        const boxes = deriveOrderBoxCount(deliveredQty, boxSize);
        return {
            ...item,
            boxSize,
            deliveredBoxCount: boxes != null ? boxes : 1,
            actualOrderAmount: deliveredQty
        };
    };

    /**
     * Inline table edits for DN compare (delivered/waste) and Return (qty/reason/description).
     */
    onInlineItemFieldChange = (rowData, field, value) => {
        if (!this.areItemsEditable()) {
            return;
        }
        if (this.isDeliveryNote() && this.state.assignedPurchaseOrder) {
            this.onDeliveryCompareInlineChange(rowData, field, value);
            return;
        }
        if (this.isDeliveryNote() && field === 'reasonCode') {
            if (!rowData) {
                return;
            }
            const nextItem = {...rowData, reasonCode: value || null};
            const itemList = upsertRequisitionItem(this.state.requisition.itemList, nextItem).itemList;
            this.setState(prev => ({
                requisition: {...prev.requisition, itemList}
            }));
            return;
        }
        if (this.isReturnNote()) {
            this.onReturnInlineChange(rowData, field, value);
        }
    };

    onDeliveryCompareInlineChange = (rowData, field, value) => {
        const barcode = String(rowData?.barcode || '').trim();
        if (!barcode) {
            return;
        }
        let itemList = [...(this.state.requisition.itemList || [])];
        let item = itemList.find(i => String(i?.barcode || '').trim() === barcode) || null;
        if (!item) {
            item = this.createDnItemFromPoOrRow(rowData);
            itemList = upsertRequisitionItem(itemList, item).itemList;
            item = itemList.find(i => String(i?.barcode || '').trim() === barcode) || item;
        }
        let nextItem = {...item};
        if (field === 'deliveredQty') {
            nextItem = this.applyDeliveredQtyToItem(nextItem, value);
        } else if (field === 'damagedQty') {
            const raw = value === '' || value == null ? 0 : Number(value);
            nextItem.damagedQuantity = Number.isNaN(raw) || raw < 0 ? 0 : raw;
        } else if (field === 'reasonCode') {
            nextItem.reasonCode = value || null;
        } else {
            return;
        }
        itemList = upsertRequisitionItem(itemList, nextItem).itemList;
        this.setState(prev => ({
            requisition: {...prev.requisition, itemList}
        }), () => this.refreshComparisonRows());
    };

    onReturnInlineChange = (rowData, field, value) => {
        if (!rowData) {
            return;
        }
        let nextItem = {...rowData};
        if (field === 'actualOrderAmount') {
            nextItem = this.applyDeliveredQtyToItem(nextItem, value);
        } else if (field === 'reasonCode') {
            nextItem.reasonCode = value || null;
        } else if (field === 'description') {
            nextItem.description = value != null ? String(value).slice(0, 50) : null;
        } else {
            return;
        }
        const itemList = upsertRequisitionItem(this.state.requisition.itemList, nextItem).itemList;
        this.setState(prev => ({
            requisition: {...prev.requisition, itemList}
        }));
    };

    refreshComparisonRows = () => {
        const assignedPurchaseOrder = this.state.assignedPurchaseOrder;
        if (!assignedPurchaseOrder) {
            this.setState({comparisonRows: []});
            return [];
        }
        const comparisonRows = buildDeliveryPoComparisonRows(
            assignedPurchaseOrder.itemList,
            this.state.requisition.itemList
        );
        this.setState({comparisonRows});
        return comparisonRows;
    };

    findDeliveryNoteItemByBarcode = (barcode) => {
        const key = String(barcode || '').trim();
        if (!key) {
            return null;
        }
        return (this.state.requisition.itemList || []).find(item => String(item?.barcode || '').trim() === key) || null;
    };

    getDeliveryTableData = () => {
        if (!this.state.assignedPurchaseOrder) {
            return this.state.requisition.itemList || [];
        }
        return (this.state.comparisonRows || []).map(row => {
            const dnItem = this.findDeliveryNoteItemByBarcode(row.barcode);
            return {
                ...row,
                hideButton: !dnItem || !this.isEditable(),
                _dnItem: dnItem
            };
        });
    };

    applyCostWarnings = (requisition) => {
        if (!requisition?.id || requisition.requisitionStatus !== 'OPEN') {
            return Promise.resolve(requisition);
        }
        return this.purchaseRequisitionService.getCostWarnings(requisition.id).then(warnings => {
            if (GeneralUtils.isNullOrEmpty(warnings) || !GeneralUtils.isNullOrEmpty(warnings.type)) {
                return requisition;
            }
            return {
                ...requisition,
                itemList: applyCostWarningsToItems(requisition.itemList, warnings)
            };
        }).catch(() => requisition);
    };

    refreshRequisitionWithCostWarnings = (requisition) => {
        return this.applyCostWarnings(requisition).then(enriched => {
            this.setState({requisition: enriched});
            return enriched;
        });
    };

    isEditable = () => {
        if (this.isApproved()) {
            return false;
        }
        const status = this.state.requisition?.requisitionStatus;
        return status === 'OPEN' || status === 'DELIVERY_NOTE' || status === 'RETURN';
    };

    /** Item list locked when Return was created from DN waste (qty/reason come from DN). */
    areReturnItemsLockedFromDn = () => isReturnItemsLockedFromDeliveryNote(this.state.requisition);

    areItemsEditable = () => this.isEditable() && !this.areReturnItemsLockedFromDn();

    getRequisitionStatusLabel = (status) => {
        const match = PURCHASE_REQUISITION_STATUS.find(item => item.value === status);
        let label = match?.name || status || 'Requisition';
        if (status === 'DELIVERY_NOTE' || status === 'RETURN') {
            label = `${label} (${this.isApproved() ? 'Closed' : 'Open'})`;
        }
        return label;
    };

    hasSavedRequisition = () => !GeneralUtils.isNullOrEmpty(this.state.requisition?.id);

    showDeleteConfirmDialog = () => {
        if (!this.hasSavedRequisition() || this.isApproved()) {
            return;
        }
        this.setState({displayDeleteConfirmDialog: true});
    };

    deleteRequisition = () => {
        const id = this.state.requisition?.id;
        if (GeneralUtils.isNullOrEmpty(id)) {
            this.setState({displayDeleteConfirmDialog: false});
            return;
        }

        this.setState({loading: true, displayDeleteConfirmDialog: false});
        this.purchaseRequisitionService.delete(id).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                window.location.href = getPurchaseRequisitionListReturnHash();
            } else {
                this.setState({loading: false});
            }
        }).catch(() => this.setState({loading: false}));
    };

    saveRequisition = () => {
        if (!this.isEditable()) {
            return;
        }
        const requisition = {...this.state.requisition};
        const itemList = Array.isArray(requisition.itemList) ? requisition.itemList : [];

        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(requisition.supplierId)) {
            toast.warn('Please select a supplier!');
            return;
        }

        const allowEmptyDraft = this.isDeliveryNote() || this.isReturnNote();
        if (itemList.length === 0 && !allowEmptyDraft) {
            toast.warn('Please add at least one item!');
            return;
        }

        this.setState({loading: true});
        this.persistRequisition(requisition, {redirectIfNew: true});
    };

    /**
     * Persist current document; optional callback after success (used for PO/DN assign before items).
     */
    persistRequisition = (requisition, options = {}) => {
        const {redirectIfNew = false, onSuccess} = options;
        return persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false});
                if (result.reason === 'empty') {
                    toast.warn('Please add at least one item!');
                }
                return result;
            }
            const saved = result.requisition;
            const hadId = !GeneralUtils.isNullOrEmpty(requisition.id);
            return this.applyCostWarnings(saved).then(enriched => new Promise(resolve => {
                this.setState({
                    requisition: enriched,
                    loading: false,
                    assignedPurchaseOrder: GeneralUtils.isNullOrEmpty(enriched.assignedPurchaseRequisitionId)
                        ? null
                        : this.state.assignedPurchaseOrder
                }, () => {
                    if (!hadId && enriched.id) {
                        const modeSuffix = this.isDeliveryNote()
                            ? '&mode=delivery'
                            : (this.isReturnNote() ? '&mode=return' : '');
                        const hash = '#/purchaseRequisitionSave?' + enriched.id + modeSuffix;
                        if (redirectIfNew && typeof onSuccess !== 'function') {
                            window.location.href = hash;
                        } else {
                            try {
                                window.history.replaceState(null, '', hash);
                            } catch (e) {
                                // ignore
                            }
                        }
                    } else if (enriched.assignedPurchaseRequisitionId) {
                        this.loadAssignedPurchaseOrder(enriched.assignedPurchaseRequisitionId);
                    } else {
                        this.refreshComparisonRows();
                    }
                    if (typeof onSuccess === 'function') {
                        onSuccess(enriched);
                    }
                    resolve({success: true, requisition: enriched});
                });
            }));
        });
    };

    /**
     * Auto-create empty Return / Delivery Note so assignment can happen before items are added.
     */
    ensureDraftSavedForAssignment = (onReady) => {
        if (!this.isEditable()) {
            return;
        }
        if (this.hasSavedRequisition()) {
            if (typeof onReady === 'function') {
                onReady();
            }
            return;
        }
        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(this.state.requisition?.supplierId)) {
            toast.warn('Please select a supplier first');
            this.openDeliverySupplierDialog();
            return;
        }
        if (!this.isDeliveryNote() && !this.isReturnNote()) {
            toast.warn('Please save the document first');
            return;
        }
        const requisition = {
            ...this.state.requisition,
            itemList: Array.isArray(this.state.requisition?.itemList) ? this.state.requisition.itemList : []
        };
        this.setState({loading: true});
        this.persistRequisition(requisition, {
            redirectIfNew: false,
            onSuccess: () => {
                if (typeof onReady === 'function') {
                    onReady();
                }
            }
        });
    };

    onDataSelect = (data) => {
        let itemData = data;
        // Comparison rows (PO assigned): only open real DN items, not PO-only / unexpected rows
        if (this.isDeliveryNote() && this.state.assignedPurchaseOrder) {
            if (data?.matchStatus === 'MISSING') {
                if (this.isEditable()) {
                    toast.warn('Ordered on Purchase Order but not received on Delivery Note yet');
                }
                return;
            }
            const dnItem = data?._dnItem || this.findDeliveryNoteItemByBarcode(data?.barcode);
            if (!dnItem) {
                if (this.isEditable()) {
                    toast.warn('Item is not on this Delivery Note');
                }
                return;
            }
            itemData = dnItem;
        }
        // Allow opening items when document is not editable — form is view-only (Close only).
        GeneralUtils.openDialogThenRef(this, {displayDialog: true}, () => this.refModelSave, (ref) => ref.setData(itemData));
    };

    addNewItem = () => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId)) {
            toast.warn('Please select a supplier first');
            this.openDeliverySupplierDialog();
            return;
        }
        const item = Object.assign({}, defaultItem);
        if (this.isDeliveryNote() || this.isReturnNote()) {
            item.boxSize = 1;
            item.deliveredBoxCount = 1;
        }
        if (this.isDeliveryNote()) {
            item.supplierId = this.state.requisition.supplierId ?? null;
            item.supplierName = this.state.requisition.supplierName ?? null;
            item.supplierBssId = this.state.requisition.supplierBssId ?? null;
            item.currentSupplierId = this.state.requisition.supplierId ?? null;
            item.currentSupplierName = this.state.requisition.supplierName ?? null;
        }
        if (!this.isDeliveryNote() && !this.isReturnNote()) {
            item.boxSize = 1;
            item.deliveredBoxCount = 1;
        }
        GeneralUtils.openDialogThenRef(
            this,
            {displayDialog: true},
            () => this.refModelSave,
            (ref) => ref.setData(item)
        );
    };

    persistItemAndContinue = (itemData, closeAfterSave = true) => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        if (this.isDeliveryNote() && GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId)) {
            toast.warn('Please select a supplier first');
            this.openDeliverySupplierDialog();
            return;
        }
        if (isDuplicateBarcodeInList(this.state.requisition.itemList, itemData)) {
            toast.warn("Don't allow duplicate entries");
            return;
        }
        const {itemList} = upsertRequisitionItem(this.state.requisition.itemList, itemData);
        const requisition = {...this.state.requisition, itemList};
        const hadRequisitionId = !GeneralUtils.isNullOrEmpty(requisition.id);

        this.setState({loading: true});
        persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false});
                return;
            }
            this.applyCostWarnings(result.requisition).then(enriched => {
                this.setState({requisition: enriched, loading: false}, () => {
                    this.refreshComparisonRows();
                    if (!hadRequisitionId && enriched.id) {
                        window.history.replaceState(null, '', '#purchaseRequisitionSave?' + enriched.id);
                    }
                    if (closeAfterSave) {
                        this.closeItemDialog();
                        return;
                    }
                    const nextItem = Object.assign({}, defaultItem);
                    if (this.isDeliveryNote() || this.isReturnNote()) {
                        nextItem.boxSize = 1;
                        nextItem.deliveredBoxCount = 1;
                    }
                    if (this.isDeliveryNote()) {
                        nextItem.supplierId = this.state.requisition.supplierId ?? null;
                        nextItem.supplierName = this.state.requisition.supplierName ?? null;
                        nextItem.supplierBssId = this.state.requisition.supplierBssId ?? null;
                        nextItem.currentSupplierId = this.state.requisition.supplierId ?? null;
                        nextItem.currentSupplierName = this.state.requisition.supplierName ?? null;
                    }
                    if (!this.isDeliveryNote() && !this.isReturnNote()) {
                        nextItem.boxSize = 1;
                        nextItem.deliveredBoxCount = 1;
                    }
                    GeneralUtils.openDialogThenRef(
                        this,
                        {displayDialog: true},
                        () => this.refModelSave,
                        (ref) => ref.setData(nextItem)
                    );
                });
            });
        });
    };

    saveItem = (itemData) => this.persistItemAndContinue(itemData, true);

    saveItemAndNext = (itemData) => this.persistItemAndContinue(itemData, false);

    closeItemDialog = () => {
        this.setState({displayDialog: false});
    };

    __handleChange = (e) => {
        if (!this.isEditable()) {
            return;
        }
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        this.setState(prev => ({
            requisition: {...prev.requisition, [e.target.name]: value}
        }));
    };

    applyDeliverySupplier = (supplier) => {
        if (!this.isEditable() || !this.isDeliveryNote()) {
            return;
        }
        const supplierId = supplier?.id != null ? Number(supplier.id) : null;
        const supplierName = supplier?.name || null;
        const supplierBssId = supplier?.bssId || null;
        const previousSupplierId = this.state.requisition.supplierId;
        const supplierChanged = Number(previousSupplierId) !== Number(supplierId)
            && !(GeneralUtils.isNullOrEmpty(previousSupplierId) && GeneralUtils.isNullOrEmpty(supplierId));
        const hadAssigned = !GeneralUtils.isNullOrEmpty(this.state.requisition.assignedPurchaseRequisitionId);
        const shouldClearAssigned = supplierChanged && hadAssigned;

        this.setState(prev => ({
            displaySupplierFilterDialog: false,
            requisition: {
                ...prev.requisition,
                supplierId,
                supplierName,
                supplierBssId,
                ...(shouldClearAssigned ? {
                    assignedPurchaseRequisitionId: null,
                    assignedPurchaseRequisitionNo: null
                } : {})
            },
            ...(shouldClearAssigned ? {
                assignedPurchaseOrder: null,
                comparisonRows: [],
                comparisonVersion: (prev.comparisonVersion || 0) + 1
            } : {})
        }), () => {
            if (!supplierChanged || !this.hasSavedRequisition()) {
                return;
            }
            const persistSupplier = () => {
                const items = this.state.requisition.itemList || [];
                if (items.length === 0) {
                    return;
                }
                persistRequisitionToDb(this.state.requisition, this.purchaseRequisitionService).then(result => {
                    if (!result.success) {
                        return;
                    }
                    this.setState(prev => ({
                        requisition: {
                            ...result.requisition,
                            supplierId: result.requisition.supplierId ?? prev.requisition.supplierId,
                            supplierName: result.requisition.supplierName ?? prev.requisition.supplierName,
                            supplierBssId: result.requisition.supplierBssId ?? prev.requisition.supplierBssId,
                            itemList: prev.requisition.itemList || result.requisition.itemList
                        }
                    }));
                });
            };
            if (shouldClearAssigned) {
                toast.info('Assigned purchase order cleared because supplier changed');
                this.purchaseRequisitionService.assignPurchaseOrder(this.state.requisition.id, null)
                    .then(() => persistSupplier())
                    .catch(() => persistSupplier());
            } else {
                persistSupplier();
            }
        });
    };

    openDeliverySupplierDialog = () => {
        if (!this.isEditable() || !this.isDeliveryNote()) {
            return;
        }
        this.setState({displaySupplierFilterDialog: true});
    };

    closeDeliverySupplierDialog = () => {
        this.setState({displaySupplierFilterDialog: false});
    };

    clearDeliverySupplier = () => {
        this.applyDeliverySupplier(null);
    };

    /** Keep row delete action as the last column (right edge of the table). */
    pinDeleteColumnLast = (fields) => {
        const list = Array.isArray(fields) ? fields.slice() : [];
        const deleteIndex = list.findIndex(f => f.field === 'button.delete');
        if (deleteIndex < 0) {
            return list;
        }
        const deleteField = {
            ...list[deleteIndex],
            visible: true,
            style: {
                ...(list[deleteIndex].style || {}),
                width: '3.5rem',
                minWidth: '3.5rem',
                maxWidth: '3.5rem',
                textAlign: 'center'
            },
            headerStyle: {
                ...(list[deleteIndex].headerStyle || {}),
                width: '3.5rem',
                minWidth: '3.5rem',
                textAlign: 'center'
            },
            bodyStyle: {
                width: '3.5rem',
                minWidth: '3.5rem',
                textAlign: 'center',
                paddingLeft: '0.25rem',
                paddingRight: '0.25rem'
            }
        };
        list.splice(deleteIndex, 1);
        list.push(deleteField);
        return list;
    };

    getItemListFields = () => {
        const isDelivery = this.isDeliveryNote();
        const isReturn = this.isReturnNote();
        const hasAssignedPo = isDelivery && !!this.state.assignedPurchaseOrder;
        const itemsEditable = this.areItemsEditable();
        if (hasAssignedPo) {
            const editable = itemsEditable;
            return this.pinDeleteColumnLast(PurchaseRequisitionDeliveryCompareColumn.fields
                .filter(field => {
                    if (field.field === 'button.delete' && !editable) {
                        return false;
                    }
                    // DN header already has document supplier — no per-row supplier column.
                    if (field.field === 'currentSupplierName') {
                        return false;
                    }
                    return field.visible !== false;
                })
                .map(field => {
                    if (!editable) {
                        return {...field, visible: true};
                    }
                    if (field.field === 'deliveredQty') {
                        return {...field, visible: true, customBody: 'inlineDeliveredQtyBody'};
                    }
                    if (field.field === 'damagedQty') {
                        return {
                            ...field,
                            visible: true,
                            customBody: 'deliveryCompareDamagedBody'
                        };
                    }
                    if (field.field === 'reasonCode') {
                        return {
                            ...field,
                            header: 'Rejected Reason',
                            visible: true,
                            customBody: 'inlineReasonCodeBody'
                        };
                    }
                    return {...field, visible: true};
                }));
        }
        const deliveryFields = new Set([
            'barcode',
            'itemNameWithSizeAndQuantity',
            'boxSize',
            'deliveredBoxCount',
            'actualOrderAmount',
            'damagedQuantity',
            'reasonCode',
            'description',
            'expiryDate',
            'button.delete'
        ]);
        const returnFields = new Set([
            'barcode',
            'itemNameWithSizeAndQuantity',
            'boxSize',
            'deliveredBoxCount',
            'actualOrderAmount',
            'currentCost',
            'reasonCode',
            'description',
            'button.delete'
        ]);
        return this.pinDeleteColumnLast(PurchaseRequisitionItemColumn.fields
            .filter(field => {
                if (field.field === 'button.delete' && !this.areItemsEditable()) {
                    return false;
                }
                if (isDelivery) {
                    return deliveryFields.has(field.field);
                }
                if (isReturn) {
                    return returnFields.has(field.field);
                }
                // PR / Purchase Order list: keep stock + boxes even if JSON default is hidden
                if (field.field === 'damagedQuantity' || field.field === 'expiryDate'
                    || field.field === 'reasonCode'
                    || field.field === 'itemUnitMeasure' || field.field === 'itemSize') {
                    return false;
                }
                if (field.field === 'currentStock' || field.field === 'deliveredBoxCount' || field.field === 'boxSize') {
                    return true;
                }
                return field.visible !== false;
            })
            .map(field => {
                if (isReturn) {
                    const returnItemsEditable = this.areItemsEditable();
                    if (field.field === 'itemNameWithSizeAndQuantity') {
                        return {...field, field: 'longName', header: 'Name', customBody: 'longNameBody', visible: true};
                    }
                    if (field.field === 'boxSize') {
                        return {...field, header: 'Box Qty', visible: true};
                    }
                    if (field.field === 'deliveredBoxCount') {
                        return {...field, header: 'Boxes', visible: true};
                    }
                    if (field.field === 'actualOrderAmount') {
                        return {
                            ...field,
                            header: 'Return Qty',
                            visible: true,
                            customBody: returnItemsEditable ? 'inlineReturnQtyBody' : undefined
                        };
                    }
                    if (field.field === 'currentCost') {
                        return {...field, header: 'Cur. Unit Cost', visible: true};
                    }
                    if (field.field === 'reasonCode') {
                        return {
                            ...field,
                            header: 'Reason',
                            visible: true,
                            customBody: 'inlineReasonCodeBody'
                        };
                    }
                    if (field.field === 'description') {
                        return {
                            ...field,
                            header: 'Return Description',
                            visible: true,
                            customBody: returnItemsEditable ? 'inlineDescriptionBody' : undefined
                        };
                    }
                    return {...field, visible: true};
                }
                if (!isDelivery && !isReturn) {
                    if (field.field === 'itemNameWithSizeAndQuantity') {
                        return {
                            ...field,
                            field: 'longName',
                            header: 'Name',
                            customBody: 'longNameBody',
                            visible: true
                        };
                    }
                    if (field.field === 'currentStock') {
                        return {...field, header: 'Cur. Stock', visible: true};
                    }
                    if (field.field === 'boxSize') {
                        return {...field, header: 'Box Qty', visible: true};
                    }
                    if (field.field === 'deliveredBoxCount') {
                        return {...field, header: 'Order', visible: true};
                    }
                    if (field.field === 'currentCost') {
                        return {...field, header: 'Cur. Unit Cost', visible: true};
                    }
                    if (field.field === 'actualOrderAmount') {
                        return {
                            ...field,
                            header: 'Total Pieces',
                            customBody: 'actualOrderHighlightBody',
                            visible: true
                        };
                    }
                    return field;
                }
                if (!isDelivery) {
                    return field;
                }
                if (field.field === 'itemNameWithSizeAndQuantity') {
                    return {...field, field: 'longName', header: 'Name', customBody: 'longNameBody', visible: true};
                }
                if (field.field === 'boxSize') {
                    return {...field, header: 'Box Qty', visible: true};
                }
                if (field.field === 'deliveredBoxCount') {
                    return {...field, header: 'Boxes', visible: true};
                }
                if (field.field === 'damagedQuantity') {
                    return {...field, header: 'Rejected Qty', visible: true};
                }
                if (field.field === 'reasonCode') {
                    return {
                        ...field,
                        header: 'Rejected Reason',
                        visible: true,
                        customBody: this.isEditable() ? 'inlineReasonCodeBody' : undefined
                    };
                }
                if (field.field === 'description') {
                    return {...field, header: 'Description', visible: true};
                }
                if (field.field === 'actualOrderAmount') {
                    return {...field, header: 'Total Qty', visible: true};
                }
                if (field.field === 'expiryDate') {
                    return {...field, visible: true};
                }
                return {...field, visible: true};
            }));
    };

    getDeliveryPdfOptions = () => {
        if (!this.isDeliveryNote() || !this.state.assignedPurchaseOrder) {
            return {};
        }
        return {
            purchaseOrderItems: this.state.assignedPurchaseOrder.itemList || [],
            deliveryNoteItems: this.state.requisition.itemList || [],
            documentSupplierId: this.state.requisition.supplierId ?? null
        };
    };

    /**
     * Supplier groups for Print PDF. When DN has an assigned PO but empty lines,
     * still allow a group so missing-on-DN PO rows can print.
     */
    getSupplierGroupsForPrint = () => {
        const items = this.state.requisition.itemList || [];
        const groups = groupItemsBySupplier(items);
        if (groups.length > 0) {
            return groups;
        }
        if (this.isDeliveryNote() && this.state.assignedPurchaseOrder) {
            const r = this.state.requisition || {};
            const supplierId = r.supplierId ?? null;
            return [{
                key: supplierId != null ? String(supplierId) : 'unknown',
                supplierId,
                supplierName: r.supplierName || 'Supplier',
                items: []
            }];
        }
        return groups;
    };

    canPrintDocument = () => {
        const items = this.state.requisition.itemList || [];
        if ((items || []).length > 0) {
            return true;
        }
        return this.isDeliveryNote()
            && !!this.state.assignedPurchaseOrder
            && (this.state.assignedPurchaseOrder.itemList || []).length > 0;
    };

    printSupplierPdf = (group) => {
        exportSupplierPdf(group, this.state.requisition, this.getDeliveryPdfOptions());
    };

    printBulkSupplierPdf = () => {
        exportBulkSupplierPdf(
            this.getSupplierGroupsForPrint(),
            this.state.requisition,
            this.getDeliveryPdfOptions()
        );
    };

    renderItemListToolbar() {
        const editable = this.areItemsEditable();
        const items = this.state.requisition?.itemList || [];
        const isDelivery = this.isDeliveryNote();
        const isReturn = this.isReturnNote();
        if (!editable && items.length === 0 && !isDelivery && !isReturn) {
            return null;
        }
        return (
            <div className="d-flex justify-content-end mb-3 flex-wrap gap-2 align-items-center">
                {editable &&
                    <Button color="outline-primary" className="settings-page__btn--add" onClick={this.addNewItem}>
                        <i className="pi pi-plus" aria-hidden="true"/>
                        <Translate contentKey="entity.action.add">Add Item</Translate>
                    </Button>
                }
                {this.canPrintDocument() &&
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--action"
                        onClick={this.printBulkSupplierPdf}
                    >
                        <i className="pi pi-copy" aria-hidden="true"/>
                        Bulk Print
                    </Button>
                }
            </div>
        );
    }

    renderItemList() {
        // Return uses supplier groups + Email sent badge (same as Purchase Order).
        if (this.isReturnNote()) {
            return this.renderSupplierGroups();
        }
        if (this.isDeliveryNote()) {
            const hasAssignedPo = !!this.state.assignedPurchaseOrder;
            if (!hasAssignedPo) {
                // Same supplier sections as PR/PO — Print PDF sits next to supplier name (no truncated label).
                return this.renderSupplierGroups();
            }
            const items = this.getDeliveryTableData();
            const issueCount = countDeliveryPoComparisonIssues(this.state.comparisonRows);
            const printGroups = this.getSupplierGroupsForPrint();
            return (
                <div>
                    <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                        <div className={`purchase-requisition-compare-dialog__summary mb-0${issueCount > 0 ? ' has-issues' : ''}`}>
                            {issueCount > 0
                                ? `${issueCount} difference(s) in total pieces between Purchase Order and Delivery Note.`
                                : 'Total pieces on Purchase Order and Delivery Note match.'}
                        </div>
                        {this.canPrintDocument() && printGroups.length > 0 &&
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--action"
                                onClick={() => this.printSupplierPdf(printGroups[0])}
                            >
                                <i className="pi pi-file-pdf" aria-hidden="true"/>
                                <Translate contentKey="entity.action.pdf">Print PDF</Translate>
                            </Button>
                        }
                    </div>
                    <PurchaseRequisitionItemDataTable
                        key={`doc-items-${this.state.assignedPurchaseOrder?.id || 'po'}-${this.state.comparisonVersion || 0}`}
                        data={items}
                        selectionMode="single"
                        paginator={true}
                        rows={20}
                        dataKey="barcode"
                        onDataSelect={this.onDataSelect}
                        delete={this.isEditable() ? this.showRemoveItemConfirm : undefined}
                        fields={this.getItemListFields()}
                        inlineEditEnabled={this.isEditable()}
                        onInlineFieldChange={this.onInlineItemFieldChange}
                        reasonOptions={DELIVERY_WASTE_REASON_CODE}
                    />
                </div>
            );
        }
        return this.renderSupplierGroups();
    }

    showRemoveItemConfirm = (rowData) => {
        if (!this.areItemsEditable()) {
            if (this.areReturnItemsLockedFromDn()) {
                toast.warn('Items from Delivery Note cannot be changed');
            }
            return;
        }
        const itemToRemove = this.isDeliveryNote() && this.state.assignedPurchaseOrder
            ? (rowData?._dnItem || this.findDeliveryNoteItemByBarcode(rowData?.barcode))
            : rowData;
        if (!itemToRemove) {
            toast.warn(this.isDeliveryNote() ? 'Item is not on this Delivery Note' : 'Item not found');
            return;
        }
        this.setState({
            displayRemoveItemConfirmDialog: true,
            itemToRemove
        });
    };

    confirmRemoveItem = () => {
        const itemToRemove = this.state.itemToRemove;
        if (!itemToRemove) {
            this.setState({displayRemoveItemConfirmDialog: false});
            return;
        }

        const itemList = removeItemFromList(this.state.requisition.itemList, itemToRemove);
        const allowEmpty = this.isDeliveryNote() || this.isReturnNote();
        if (itemList.length === 0 && !allowEmpty) {
            toast.warn('Requisition must have at least one item!');
            this.setState({displayRemoveItemConfirmDialog: false, itemToRemove: null});
            return;
        }

        const requisition = {...this.state.requisition, itemList};
        if (!this.hasSavedRequisition()) {
            this.setState({
                requisition,
                displayRemoveItemConfirmDialog: false,
                itemToRemove: null
            });
            return;
        }

        this.setState({loading: true, displayRemoveItemConfirmDialog: false});
        persistRequisitionToDb(requisition, this.purchaseRequisitionService).then(result => {
            if (!result.success) {
                this.setState({loading: false, itemToRemove: null});
                return;
            }
            this.applyCostWarnings(result.requisition).then(enriched => {
                this.setState({requisition: enriched, loading: false, itemToRemove: null}, () => {
                    this.refreshComparisonRows();
                });
            });
        });
    };

    openAssignPurchaseOrderDialog = () => {
        if (!this.isDeliveryNote()) {
            return;
        }
        this.ensureDraftSavedForAssignment(() => {
            if (GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId)) {
                toast.warn('Please select a supplier first');
                this.openDeliverySupplierDialog();
                return;
            }
            this.setState({
                selectedPurchaseOrderId: this.state.requisition.assignedPurchaseRequisitionId || '',
                displayAssignPurchaseOrderDialog: true
            });
        });
    };

    closeAssignPurchaseOrderDialog = () => {
        this.setState({
            displayAssignPurchaseOrderDialog: false,
            selectedPurchaseOrderId: null
        });
    };

    confirmAssignPurchaseOrder = () => {
        const deliveryNoteId = this.state.requisition.id;
        const selectedId = this.state.selectedPurchaseOrderId;
        const assignedPurchaseRequisitionId = GeneralUtils.isNullOrEmpty(selectedId) ? null : Number(selectedId);
        this.setState({
            loading: true,
            displayAssignPurchaseOrderDialog: false,
            assignedPurchaseOrder: null,
            comparisonRows: []
        });
        this.purchaseRequisitionService.assignPurchaseOrder(deliveryNoteId, assignedPurchaseRequisitionId).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({loading: false});
                return;
            }
            const saved = normalizeRequisition(response);
            this.setState(prev => ({
                requisition: {
                    ...prev.requisition,
                    assignedPurchaseRequisitionId: saved.assignedPurchaseRequisitionId ?? null,
                    assignedPurchaseRequisitionNo: saved.assignedPurchaseRequisitionNo || null,
                    // keep current DN items; assign response is only for linkage fields
                    itemList: prev.requisition.itemList || []
                },
                selectedPurchaseOrderId: null,
                assignedPurchaseOrder: null,
                comparisonRows: [],
                comparisonVersion: (prev.comparisonVersion || 0) + 1
            }), () => {
                this.loadAssignedPurchaseOrder(assignedPurchaseRequisitionId)
                    .then(po => {
                        if (assignedPurchaseRequisitionId && po) {
                            return this.seedDeliveryItemsFromPurchaseOrderIfEmpty(po);
                        }
                        return null;
                    })
                    .then(() => this.setState({loading: false}))
                    .catch(() => this.setState({loading: false}));
            });
        }).catch(() => this.setState({loading: false}));
    };

    onAssignPurchaseOrderSelect = (data) => {
        if (!data?.id) {
            return;
        }
        this.setState({selectedPurchaseOrderId: data.id}, () => this.confirmAssignPurchaseOrder());
    };

    clearAssignedPurchaseOrder = () => {
        this.setState({selectedPurchaseOrderId: ''}, () => this.confirmAssignPurchaseOrder());
    };

    renderDeliverySupplierDialog() {
        return (
            <Dialog
                visible={this.state.displaySupplierFilterDialog}
                header="Supplier"
                onHide={this.closeDeliverySupplierDialog}
                style={GeneralUtils.getDialogStyleForSupplierFilter()}
            >
                <SupplierFilter
                    onDataSelect={this.applyDeliverySupplier}
                    closeDisplayDialog={this.closeDeliverySupplierDialog}
                />
            </Dialog>
        );
    }

    renderAssignPurchaseOrderDialog() {
        const deliveryNoteId = this.state.requisition.id;
        return (
            <Dialog
                visible={this.state.displayAssignPurchaseOrderDialog}
                header="Purchase Order"
                onHide={this.closeAssignPurchaseOrderDialog}
                style={{width: '720px', maxWidth: '95vw'}}
            >
                <div className="settings-page settings-page--dialog settings-page--lookup-picker purchase-requisition-assign-po-dialog">
                    <div className="purchase-requisition-po-card purchase-requisition-po-card--dialog">
                        <div className="purchase-requisition-po-card__title">Purchase Order</div>
                    </div>
                    <div className="settings-page__table-wrap settings-page__table-wrap--lookup-dialog">
                        {this.state.displayAssignPurchaseOrderDialog && !GeneralUtils.isNullOrEmpty(deliveryNoteId) &&
                            <DataTable
                                key={`assign-po-${deliveryNoteId}`}
                                fields={PurchaseRequisitionAssignPoColumn.fields}
                                objectName={PurchaseRequisitionAssignPoColumn.name}
                                dataURL="inventory/PurchaseRequisition/available-purchase-orders/all"
                                parameter={deliveryNoteId}
                                rows={10}
                                paginator={true}
                                selectionMode="single"
                                onDataSelect={this.onAssignPurchaseOrderSelect}
                            />
                        }
                    </div>
                    <div className="settings-page__actions settings-page__actions--dialog-footer purchase-requisition-assign-po-dialog__footer">
                        {this.state.requisition.assignedPurchaseRequisitionId &&
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--cancel"
                                onClick={this.clearAssignedPurchaseOrder}
                            >
                                Clear
                            </Button>
                        }
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--cancel settings-page__btn--close"
                            onClick={this.closeAssignPurchaseOrderDialog}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }

    openAssignDeliveryNoteDialog = () => {
        if (!this.isReturnNote()) {
            return;
        }
        this.ensureDraftSavedForAssignment(() => {
            this.setState({
                selectedDeliveryNoteId: this.state.requisition.assignedPurchaseRequisitionId || '',
                displayAssignDeliveryNoteDialog: true
            });
        });
    };

    closeAssignDeliveryNoteDialog = () => {
        this.setState({
            displayAssignDeliveryNoteDialog: false,
            selectedDeliveryNoteId: null
        });
    };

    confirmAssignDeliveryNote = () => {
        const returnId = this.state.requisition.id;
        const selectedId = this.state.selectedDeliveryNoteId;
        const assignedPurchaseRequisitionId = GeneralUtils.isNullOrEmpty(selectedId) ? null : Number(selectedId);
        this.setState({
            loading: true,
            displayAssignDeliveryNoteDialog: false
        });
        this.purchaseRequisitionService.assignDeliveryNote(returnId, assignedPurchaseRequisitionId).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({loading: false});
                return;
            }
            const saved = normalizeRequisition(response);
            this.setState(prev => ({
                requisition: {
                    ...prev.requisition,
                    assignedPurchaseRequisitionId: saved.assignedPurchaseRequisitionId ?? null,
                    assignedPurchaseRequisitionNo: saved.assignedPurchaseRequisitionNo || null,
                    itemList: prev.requisition.itemList || []
                },
                selectedDeliveryNoteId: null
            }), () => {
                this.loadAssignedPurchaseOrder(assignedPurchaseRequisitionId)
                    .then(dn => {
                        if (assignedPurchaseRequisitionId && dn) {
                            return this.seedReturnItemsFromDeliveryNoteIfEmpty(dn);
                        }
                        return null;
                    })
                    .then(() => this.setState({loading: false}))
                    .catch(() => this.setState({loading: false}));
            });
        }).catch(() => this.setState({loading: false}));
    };

    onAssignDeliveryNoteSelect = (data) => {
        if (!data?.id) {
            return;
        }
        this.setState({selectedDeliveryNoteId: data.id}, () => this.confirmAssignDeliveryNote());
    };

    clearAssignedDeliveryNote = () => {
        this.setState({selectedDeliveryNoteId: ''}, () => this.confirmAssignDeliveryNote());
    };

    renderAssignDeliveryNoteDialog() {
        return (
            <Dialog
                visible={this.state.displayAssignDeliveryNoteDialog}
                header="Delivery Note"
                onHide={this.closeAssignDeliveryNoteDialog}
                style={{width: '720px', maxWidth: '95vw'}}
            >
                <div className="settings-page settings-page--dialog settings-page--lookup-picker purchase-requisition-assign-po-dialog">
                    <div className="purchase-requisition-po-card purchase-requisition-po-card--dialog">
                        <div className="purchase-requisition-po-card__title">Delivery Note</div>
                    </div>
                    <div className="settings-page__table-wrap settings-page__table-wrap--lookup-dialog">
                        {this.state.displayAssignDeliveryNoteDialog &&
                            <DataTable
                                key="assign-dn"
                                fields={PurchaseRequisitionAssignDnColumn.fields}
                                objectName={PurchaseRequisitionAssignDnColumn.name}
                                dataURL="inventory/PurchaseRequisition/available-delivery-notes/all"
                                rows={10}
                                paginator={true}
                                selectionMode="single"
                                onDataSelect={this.onAssignDeliveryNoteSelect}
                            />
                        }
                    </div>
                    <div className="settings-page__actions settings-page__actions--dialog-footer purchase-requisition-assign-po-dialog__footer">
                        {this.state.requisition.assignedPurchaseRequisitionId &&
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--cancel"
                                onClick={this.clearAssignedDeliveryNote}
                            >
                                Clear
                            </Button>
                        }
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--cancel settings-page__btn--close"
                            onClick={this.closeAssignDeliveryNoteDialog}
                        >
                            Close
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }

    renderAssignedPurchaseOrderCard() {
        if (this.isPurchaseOrder()) {
            const linkedId = this.state.requisition?.linkedDeliveryNoteId;
            const linkedNo = this.state.requisition?.linkedDeliveryNoteNo;
            if (GeneralUtils.isNullOrEmpty(linkedId) && GeneralUtils.isNullOrEmpty(linkedNo)) {
                return null;
            }
            return (
                <div className="purchase-requisition-po-card">
                    <div className="purchase-requisition-po-card__header">
                        <div>
                            <div className="purchase-requisition-po-card__eyebrow">Delivery Note</div>
                            <div
                                className="purchase-requisition-po-card__title purchase-requisition-po-card__title--link"
                                role="button"
                                tabIndex={0}
                                title="Open Delivery Note"
                                onClick={() => this.openLinkedDocument(linkedId)}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        this.openLinkedDocument(linkedId);
                                    }
                                }}
                            >
                                {linkedNo || ('#' + linkedId)}
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        if (this.isReturnNote()) {
            const assigned = this.state.assignedPurchaseOrder;
            const assignedNo = this.state.requisition.assignedPurchaseRequisitionNo
                || assigned?.requisitionNo;
            const editable = this.isEditable() && !this.areReturnItemsLockedFromDn();
            return (
                <div className="purchase-requisition-po-card">
                    <div className="purchase-requisition-po-card__header">
                        <div>
                            <div className="purchase-requisition-po-card__eyebrow">Delivery Note</div>
                            <div
                                className={`purchase-requisition-po-card__title${
                                    assigned?.id ? ' purchase-requisition-po-card__title--link' : ''
                                }`}
                                role={assigned?.id ? 'button' : undefined}
                                tabIndex={assigned?.id ? 0 : undefined}
                                title={assigned?.id ? 'Open Delivery Note' : undefined}
                                onClick={assigned?.id ? () => this.openLinkedDocument(assigned.id) : undefined}
                                onKeyDown={assigned?.id ? (e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        this.openLinkedDocument(assigned.id);
                                    }
                                } : undefined}
                            >
                                {assignedNo || assigned?.requisitionNo || 'Not linked'}
                            </div>
                        </div>
                        <div className="purchase-requisition-po-card__actions">
                            {editable &&
                                <i
                                    className="pi pi-search purchase-requisition-po-card__search"
                                    role="button"
                                    tabIndex={0}
                                    title="Search Delivery Note"
                                    onClick={this.openAssignDeliveryNoteDialog}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            this.openAssignDeliveryNoteDialog();
                                        }
                                    }}
                                />
                            }
                        </div>
                    </div>
                    {assigned &&
                        <div className="purchase-requisition-po-card__body">
                            <div className="purchase-requisition-po-card__field">
                                <span className="purchase-requisition-po-card__label">Create Date</span>
                                <span className="purchase-requisition-po-card__value">{assigned.createDate || '—'}</span>
                            </div>
                            <div className="purchase-requisition-po-card__field">
                                <span className="purchase-requisition-po-card__label">Status</span>
                                <span className="purchase-requisition-po-card__value">
                                    {assigned.approved ? 'Closed' : 'Open'}
                                </span>
                            </div>
                        </div>
                    }
                </div>
            );
        }
        if (!this.isDeliveryNote()) {
            return null;
        }
        const assigned = this.state.assignedPurchaseOrder;
        const assignedNo = this.state.requisition.assignedPurchaseRequisitionNo;
        const issueCount = countDeliveryPoComparisonIssues(this.state.comparisonRows);
        const editable = this.isEditable();
        const assignedId = this.state.requisition.assignedPurchaseRequisitionId || assigned?.id;
        const linkedInvoiceId = this.state.requisition.assignedInvoiceId;
        const linkedInvoiceNo = this.state.requisition.assignedInvoiceNo;
        const hasLinkedInvoice = !GeneralUtils.isNullOrEmpty(linkedInvoiceId)
            || !GeneralUtils.isNullOrEmpty(linkedInvoiceNo);

        return (
            <>
                <div className="purchase-requisition-po-card">
                    <div className="purchase-requisition-po-card__header">
                        <div>
                            <div className="purchase-requisition-po-card__eyebrow">Purchase Order</div>
                            <div
                                className={`purchase-requisition-po-card__title${
                                    assignedId ? ' purchase-requisition-po-card__title--link' : ''
                                }`}
                                role={assignedId ? 'button' : undefined}
                                tabIndex={assignedId ? 0 : undefined}
                                title={assignedId ? 'Open Purchase Order' : undefined}
                                onClick={assignedId ? () => this.openLinkedDocument(assignedId) : undefined}
                                onKeyDown={assignedId ? (e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        this.openLinkedDocument(assignedId);
                                    }
                                } : undefined}
                            >
                                {assignedNo || assigned?.requisitionNo || 'Not linked'}
                            </div>
                        </div>
                        <div className="purchase-requisition-po-card__actions">
                            {editable &&
                                <i
                                    className="pi pi-search purchase-requisition-po-card__search"
                                    role="button"
                                    tabIndex={0}
                                    title="Search Purchase Order"
                                    onClick={this.openAssignPurchaseOrderDialog}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            this.openAssignPurchaseOrderDialog();
                                        }
                                    }}
                                />
                            }
                        </div>
                    </div>
                    {assigned &&
                        <div className="purchase-requisition-po-card__body">
                            <div className="purchase-requisition-po-card__field">
                                <span className="purchase-requisition-po-card__label">Checkout Date</span>
                                <span className="purchase-requisition-po-card__value">{assigned.checkoutDate || '—'}</span>
                            </div>
                            <div className="purchase-requisition-po-card__field">
                                <span className="purchase-requisition-po-card__label">Create Date</span>
                                <span className="purchase-requisition-po-card__value">{assigned.createDate || '—'}</span>
                            </div>
                        </div>
                    }
                    {assignedNo && issueCount > 0 &&
                        <div className="purchase-requisition-po-card__footer">
                            <span className="purchase-requisition-po-card__warning">
                                {issueCount} total pieces mismatch(es) — see table below
                            </span>
                        </div>
                    }
                </div>
                {hasLinkedInvoice &&
                    <div className="purchase-requisition-po-card" style={{marginTop: '0.65rem'}}>
                        <div className="purchase-requisition-po-card__header">
                            <div>
                                <div className="purchase-requisition-po-card__eyebrow">Invoice</div>
                                <div
                                    className="purchase-requisition-po-card__title purchase-requisition-po-card__title--link"
                                    role="button"
                                    tabIndex={0}
                                    title="Open Invoice"
                                    onClick={() => this.openLinkedInvoice(linkedInvoiceId)}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            e.preventDefault();
                                            this.openLinkedInvoice(linkedInvoiceId);
                                        }
                                    }}
                                >
                                    {linkedInvoiceNo || ('#' + linkedInvoiceId)}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>
        );
    }

    openCheckoutDialog = () => {
        if (this.isDeliveryNote() || this.isReturnNote() || !this.isEditable() || !this.hasSavedRequisition()) {
            return;
        }
        if (!this.validateCheckoutItems()) {
            return;
        }
        const itemList = this.state.requisition.itemList || [];
        const groups = groupItemsBySupplier(itemList);
        const checkoutOptions = buildInitialCheckoutOptions(itemList);
        this.setState({
            displayCheckoutDialog: true,
            checkoutDialogMode: 'checkout',
            checkoutOptions,
            loggedInUserEmail: getLoggedInUserEmail()
        }, () => this.loadSupplierEmailsForCheckout(groups, checkoutOptions));
    };

    openApproveDialog = () => {
        if ((!this.isDeliveryNote() && !this.isReturnNote()) || !this.isEditable() || !this.hasSavedRequisition()) {
            return;
        }
        const itemList = this.state.requisition.itemList || [];
        if (itemList.length === 0) {
            toast.warn('Please add at least one item!');
            return;
        }
        if (this.isReturnNote()) {
            if (hasUnknownSupplierItems(itemList)) {
                toast.warn('Please set a supplier for all return items before approve');
                return;
            }
            const groups = groupItemsBySupplier(itemList);
            const checkoutOptions = buildInitialCheckoutOptions(itemList);
            this.setState({
                displayCheckoutDialog: true,
                checkoutDialogMode: 'returnApprove',
                checkoutOptions,
                loggedInUserEmail: getLoggedInUserEmail()
            }, () => this.loadSupplierEmailsForCheckout(groups, checkoutOptions));
            return;
        }
        this.setState({
            displayApproveConfirmDialog: true,
            approveOfferCreateReturn: shouldOfferCreateReturn(
                this.state.requisition,
                this.state.comparisonRows
            )
        });
    };

    executeApprove = (createReturnAfter = false) => {
        const id = this.state.requisition?.id;
        if (GeneralUtils.isNullOrEmpty(id)) {
            this.setState({displayApproveConfirmDialog: false, approveOfferCreateReturn: false});
            return;
        }
        this.setState({loading: true, displayApproveConfirmDialog: false, approveOfferCreateReturn: false});
        const payload = createReturnAfter ? {createReturnFromWaste: true} : undefined;
        this.purchaseRequisitionService.approve(id, payload).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                this.loadRequisition(id);
                return;
            }
            const createdReturnId = response.createdReturn?.id;
            if (createReturnAfter && createdReturnId) {
                // Clear spinner first — hash change does not remount this route.
                this.setState({loading: false}, () => {
                    window.location.href = '#purchaseRequisitionSave?' + createdReturnId;
                });
                return;
            }
            if (createReturnAfter && !createdReturnId) {
                toast.warn('Return Note could not be created from rejected items');
            }
            const saved = normalizeRequisition({
                ...this.state.requisition,
                ...response,
                approved: true,
                itemList: (response.itemList && response.itemList.length > 0)
                    ? response.itemList
                    : (this.state.requisition.itemList || [])
            });
            this.applyCostWarnings(saved).then(enriched => {
                this.setState({
                    requisition: {...enriched, approved: true},
                    loading: false
                }, () => this.refreshComparisonRows());
            }).catch(() => {
                this.setState({
                    requisition: {...saved, approved: true},
                    loading: false
                }, () => this.refreshComparisonRows());
            });
        }).catch(() => {
            this.setState({loading: false});
            this.loadRequisition(id);
        });
    };

    confirmReturnApprove = () => {
        if (!this.isReturnNote() || !this.isEditable() || !this.hasSavedRequisition()) {
            return;
        }
        const itemList = this.state.requisition.itemList || [];
        if (itemList.length === 0) {
            toast.warn('Please add at least one item!');
            return;
        }
        if (hasUnknownSupplierItems(itemList)) {
            toast.warn('Please set a supplier for all return items before approve');
            return;
        }
        const emailValidationErrors = validateCheckoutEmailOptions(this.state.checkoutOptions);
        if (emailValidationErrors.length > 0) {
            toast.warn(emailValidationErrors[0]);
            return;
        }
        this.setState({displayCheckoutConfirmDialog: true});
    };

    executeReturnApprove = () => {
        const id = this.state.requisition?.id;
        if (GeneralUtils.isNullOrEmpty(id)) {
            this.setState({displayCheckoutConfirmDialog: false});
            return;
        }
        const requisition = {...this.state.requisition};
        const groups = groupItemsBySupplier(requisition.itemList || []);
        const checkoutOptions = {...this.state.checkoutOptions};
        this.setState({loading: true, displayCheckoutConfirmDialog: false});
        buildCheckoutPayload(requisition, checkoutOptions).then(payload => {
            this.purchaseRequisitionService.approve(id, payload).then(response => {
                if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                    this.loadRequisition(id);
                    return;
                }
                const saved = normalizeRequisition({...response, approved: true});
                this.setState({
                    requisition: saved,
                    loading: false,
                    displayCheckoutDialog: false,
                    checkoutDialogMode: null,
                    checkoutOptions: {}
                }, async () => {
                    await this.processCheckoutOutputs(groups, saved, checkoutOptions);
                });
            }).catch(() => this.loadRequisition(id));
        }).catch(() => this.loadRequisition(id));
    };

    createReturnFromCurrentDeliveryNote = () => {
        this.setState({displayCreateReturnConfirmDialog: false});
        const deliveryNoteId = this.state.requisition?.id;
        if (GeneralUtils.isNullOrEmpty(deliveryNoteId)) {
            return;
        }
        if (!shouldOfferCreateReturn(this.state.requisition, this.state.comparisonRows)) {
            toast.warn('No rejected items found to create a Return Note');
            return;
        }
        this.setState({loading: true});
        this.purchaseRequisitionService.createReturnFromWaste(deliveryNoteId).then(response => {
            if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type) || !response.id) {
                this.setState({loading: false});
                toast.error('Could not create Return Note');
                return;
            }
            this.setState({loading: false}, () => {
                window.location.href = '#purchaseRequisitionSave?' + response.id;
            });
        }).catch(() => {
            this.setState({loading: false});
            toast.error('Could not create Return Note');
        });
    };

    closeApproveConfirmDialog = () => {
        this.setState({displayApproveConfirmDialog: false, approveOfferCreateReturn: false});
    };

    renderApproveConfirmDialog() {
        const offerReturn = this.state.approveOfferCreateReturn === true;
        if (offerReturn) {
            return (
                <Dialog
                    visible={this.state.displayApproveConfirmDialog}
                    header="Approve Delivery Note"
                    onHide={this.closeApproveConfirmDialog}
                    style={{width: '560px', maxWidth: '95vw'}}
                >
                    <div className="purchase-requisition-approve-return-dialog">
                        <p className="purchase-requisition-approve-return-dialog__message">
                            Delivery Note will be locked (Closed). Rejected items found — do you want to create a Return Note?
                        </p>
                        <div className="purchase-requisition-approve-return-dialog__actions">
                            <Button
                                color="outline-primary"
                                className="purchase-requisition-approve-return-dialog__btn purchase-requisition-approve-return-dialog__btn--cancel"
                                onClick={this.closeApproveConfirmDialog}
                            >
                                Cancel
                            </Button>
                            <Button
                                color="outline-primary"
                                className="purchase-requisition-approve-return-dialog__btn"
                                onClick={() => this.executeApprove(false)}
                            >
                                Approve Only
                            </Button>
                            <Button
                                color="outline-primary"
                                className="purchase-requisition-approve-return-dialog__btn"
                                onClick={() => this.executeApprove(true)}
                            >
                                Approve &amp; Create Return Note
                            </Button>
                        </div>
                    </div>
                </Dialog>
            );
        }
        return (
            <ModalConfirm
                header="Warning"
                ok="OK"
                onOkClick={() => this.executeApprove(false)}
                onCancelClick={this.closeApproveConfirmDialog}
                show={this.state.displayApproveConfirmDialog}
                message="Are you sure to approve? Delivery Note will be locked (Closed)."
            />
        );
    }

    loadSupplierEmailsForCheckout = (groups, checkoutOptions) => {
        const requests = groups
            .filter(group => group.supplierId)
            .map(group => this.supplierService.findById(group.supplierId).then(response => ({
                key: group.key,
                supplierEmail: (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type))
                    ? (response.email || '')
                    : ''
            })).catch(() => ({key: group.key, supplierEmail: ''})));

        if (requests.length === 0) {
            return;
        }

        Promise.all(requests).then(results => {
            const merged = {...checkoutOptions};
            results.forEach(result => {
                if (!result?.key || !merged[result.key]) {
                    return;
                }
                merged[result.key] = {
                    ...merged[result.key],
                    supplierEmail: result.supplierEmail || ''
                };
            });
            this.setState({checkoutOptions: merged});
        });
    };

    closeCheckoutDialog = () => {
        this.setState({displayCheckoutDialog: false, checkoutDialogMode: null, checkoutOptions: {}});
    };

    toggleCheckoutOption = (groupKey, field, checked) => {
        this.setState(prev => {
            const current = prev.checkoutOptions[groupKey] || {};
            const updated = {
                ...current,
                [field]: checked
            };
            if (field === 'email' && checked && GeneralUtils.isNullOrEmpty(updated.ccEmail)) {
                updated.ccEmail = getLoggedInUserEmail();
            }
            return {
                checkoutOptions: {
                    ...prev.checkoutOptions,
                    [groupKey]: updated
                }
            };
        });
    };

    updateCheckoutSupplierEmail = (groupKey, email) => {
        this.setState(prev => ({
            checkoutOptions: {
                ...prev.checkoutOptions,
                [groupKey]: {
                    ...prev.checkoutOptions[groupKey],
                    supplierEmail: email
                }
            }
        }));
    };

    updateCheckoutCcEmail = (groupKey, email) => {
        this.setState(prev => ({
            checkoutOptions: {
                ...prev.checkoutOptions,
                [groupKey]: {
                    ...prev.checkoutOptions[groupKey],
                    ccEmail: email
                }
            }
        }));
    };

    processCheckoutOutputs = async (groups, requisition, checkoutOptions) => {
        const pdfOptions = this.getDeliveryPdfOptions();
        for (const group of groups) {
            const options = checkoutOptions[group.key];
            if (!options?.print) {
                continue;
            }
            await exportSupplierPdf(group, requisition, pdfOptions);
        }
    };

    validateCheckoutItems = () => {
        const itemList = this.state.requisition.itemList || [];
        if (itemList.length === 0) {
            toast.warn('Please add at least one item!');
            return false;
        }
        const validationErrors = validateItemsForCheckout(itemList);
        const message = formatCheckoutValidationErrors(validationErrors);
        if (message) {
            toast.warn(message);
            return false;
        }
        return true;
    };

    confirmCheckout = () => {
        if (!this.isEditable() || !this.hasSavedRequisition()) {
            return;
        }

        if (!this.validateCheckoutItems()) {
            return;
        }

        const emailValidationErrors = validateCheckoutEmailOptions(this.state.checkoutOptions);
        if (emailValidationErrors.length > 0) {
            toast.warn(emailValidationErrors[0]);
            return;
        }

        this.setState({displayCheckoutConfirmDialog: true});
    };

    executeCheckout = () => {
        if (!this.validateCheckoutItems()) {
            this.setState({displayCheckoutConfirmDialog: false});
            return;
        }

        const requisition = {...this.state.requisition};
        const itemList = requisition.itemList || [];
        const groups = groupItemsBySupplier(itemList);
        const checkoutOptions = {...this.state.checkoutOptions};

        this.setState({loading: true, displayCheckoutConfirmDialog: false});
        buildCheckoutPayload(requisition, checkoutOptions).then(payload => {
            this.purchaseRequisitionService.checkout(payload.id, payload).then(response => {
                if (GeneralUtils.isNullOrEmpty(response) || !GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({loading: false});
                    return;
                }
                const saved = normalizeRequisition(response);
                const splitCount = Array.isArray(response?.createdPurchaseOrders)
                    ? response.createdPurchaseOrders.length
                    : 0;
                if (splitCount > 0) {
                    toast.success(
                        `Checkout complete: ${splitCount + 1} purchase order(s) created (one per supplier).`
                    );
                }
                this.setState({
                    requisition: saved,
                    loading: false,
                    displayCheckoutDialog: false,
                    checkoutOptions: {}
                }, async () => {
                    await this.processCheckoutOutputs(groups, saved, checkoutOptions);
                });
            }).catch(() => this.setState({loading: false}));
        }).catch(() => this.setState({loading: false}));
    };

    renderCheckoutDialog() {
        const groups = groupItemsBySupplier(this.state.requisition.itemList);
        const hasEmailSelected = Object.values(this.state.checkoutOptions || {}).some(option => option.email === true);
        const isNonProduction = !GeneralUtils.isProductionEnvironment();
        const isReturnApprove = this.state.checkoutDialogMode === 'returnApprove';
        return (
            <Dialog
                visible={this.state.displayCheckoutDialog}
                header={isReturnApprove ? 'Approve Return Note' : 'Checkout'}
                onHide={this.closeCheckoutDialog}
                style={{width: '620px', maxWidth: '95vw'}}
            >
                <div className="purchase-requisition-checkout-dialog">
                    <p className="purchase-requisition-checkout-dialog__intro">
                        {isReturnApprove
                            ? 'Select print and email options for each supplier before approving this Return.'
                            : 'Select print and email options for each supplier before completing checkout.'}
                    </p>
                    {hasEmailSelected && isNonProduction &&
                        <div className="purchase-requisition-checkout-dialog__env-note" role="status">
                            Dev/Test: email will be sent only to CC (not to To/supplier), even if you edit the addresses below.
                        </div>
                    }
                    <div className="purchase-requisition-checkout-dialog__table-wrap">
                        <table className="purchase-requisition-checkout-dialog__table">
                            <thead>
                                <tr>
                                    <th>Supplier</th>
                                    <th className="purchase-requisition-checkout-dialog__option-col">Print</th>
                                    <th className="purchase-requisition-checkout-dialog__option-col">Email</th>
                                </tr>
                            </thead>
                            <tbody>
                                {groups.map(group => {
                                    const options = this.state.checkoutOptions[group.key] || {print: false, email: false, supplierEmail: '', ccEmail: ''};
                                    const itemCount = (group.items || []).length;
                                    const totalCostLabel = formatSupplierTotalCost(getSupplierGroupTotalCost(group));
                                    return (
                                        <React.Fragment key={group.key}>
                                            <tr>
                                                <td>
                                                    <div className="purchase-requisition-checkout-dialog__supplier-name">
                                                        {group.supplierName}
                                                    </div>
                                                    <div className="purchase-requisition-checkout-dialog__item-count">
                                                        {itemCount} item{itemCount === 1 ? '' : 's'}
                                                        {totalCostLabel ? ` · Total ${totalCostLabel}` : ''}
                                                    </div>
                                                </td>
                                                <td className="purchase-requisition-checkout-dialog__option-col">
                                                    <Checkbox
                                                        inputId={`checkout-print-${group.key}`}
                                                        checked={options.print === true}
                                                        onChange={(e) => this.toggleCheckoutOption(group.key, 'print', e.checked)}
                                                    />
                                                </td>
                                                <td className="purchase-requisition-checkout-dialog__option-col">
                                                    <Checkbox
                                                        inputId={`checkout-email-${group.key}`}
                                                        checked={options.email === true}
                                                        onChange={(e) => this.toggleCheckoutOption(group.key, 'email', e.checked)}
                                                    />
                                                </td>
                                            </tr>
                                            {options.email &&
                                                <tr className="purchase-requisition-checkout-dialog__email-row">
                                                    <td colSpan={3}>
                                                        <div className="purchase-requisition-checkout-dialog__email-fields">
                                                            <div className="purchase-requisition-checkout-dialog__email-field">
                                                                <Label htmlFor={`checkout-to-email-${group.key}`} className="purchase-requisition-checkout-dialog__email-label">
                                                                    To
                                                                </Label>
                                                                <AvField
                                                                    id={`checkout-to-email-${group.key}`}
                                                                    type="email"
                                                                    name={`toEmail-${group.key}`}
                                                                    value={options.supplierEmail || ''}
                                                                    onChange={(e) => this.updateCheckoutSupplierEmail(group.key, e.target.value)}
                                                                    placeholder="supplier@example.com"
                                                                />
                                                            </div>
                                                            <div className="purchase-requisition-checkout-dialog__email-field">
                                                                <Label htmlFor={`checkout-cc-email-${group.key}`} className="purchase-requisition-checkout-dialog__email-label">
                                                                    CC
                                                                </Label>
                                                                <AvField
                                                                    id={`checkout-cc-email-${group.key}`}
                                                                    type="email"
                                                                    name={`ccEmail-${group.key}`}
                                                                    value={options.ccEmail || ''}
                                                                    onChange={(e) => this.updateCheckoutCcEmail(group.key, e.target.value)}
                                                                    placeholder="your@email.com"
                                                                />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            }
                                        </React.Fragment>
                                    );
                                })}
                            </tbody>
                        </table>
                    </div>
                    <div className="purchase-requisition-checkout-dialog__footer">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--save"
                            onClick={isReturnApprove ? this.confirmReturnApprove : this.confirmCheckout}
                        >
                            Confirm
                        </Button>
                        <Button color="outline-primary" className="settings-page__btn--cancel" onClick={this.closeCheckoutDialog}>
                            <Translate contentKey="entity.action.cancel">Cancel</Translate>
                        </Button>
                    </div>
                </div>
            </Dialog>
        );
    }

    renderSupplierGroups() {
        const groups = groupItemsBySupplier(this.state.requisition.itemList);
        if (groups.length === 0) {
            return (
                <div className="text-muted" style={{padding: '12px 0'}}>
                    No items added yet.
                </div>
            );
        }

        return groups.map(group => {
            const emailSent = wasSupplierEmailSent(this.state.requisition, group);
            const mailDetails = getSupplierMailDetails(group);
            const emailDate = this.state.requisition.checkoutDate || this.state.requisition.approvedDate;
            const totalCostLabel = formatSupplierTotalCost(getSupplierGroupTotalCost(group));
            return (
            <div key={group.key} style={{marginBottom: '24px'}}>
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap gap-2">
                    <div className="d-flex flex-column gap-1">
                        <div className="d-flex align-items-center flex-wrap gap-2">
                            <h5 className="mb-0">{group.supplierName}</h5>
                            {totalCostLabel &&
                                <span className="purchase-requisition-supplier-total-cost">
                                    Total: {totalCostLabel}
                                </span>
                            }
                            {emailSent &&
                                <span className="purchase-requisition-supplier-email-badge">
                                    <i className="pi pi-envelope" aria-hidden="true"/>
                                    Email sent{emailDate ? ` · ${emailDate}` : ''}
                                </span>
                            }
                        </div>
                        {mailDetails &&
                            <div className="purchase-requisition-supplier-email-addresses">
                                {!GeneralUtils.isNullOrEmpty(mailDetails.to) &&
                                    <span>To: {mailDetails.to}</span>
                                }
                                {!GeneralUtils.isNullOrEmpty(mailDetails.to) && !GeneralUtils.isNullOrEmpty(mailDetails.cc) &&
                                    <span className="purchase-requisition-supplier-email-addresses__sep" aria-hidden="true">·</span>
                                }
                                {!GeneralUtils.isNullOrEmpty(mailDetails.cc) &&
                                    <span>CC: {mailDetails.cc}</span>
                                }
                            </div>
                        }
                    </div>
                    <Button
                        color="outline-primary"
                        className="settings-page__btn--action"
                        onClick={() => this.printSupplierPdf(group)}
                    >
                        <i className="pi pi-file-pdf" aria-hidden="true"/>
                        <Translate contentKey="entity.action.pdf">Print PDF</Translate>
                    </Button>
                </div>
                <hr className="mt-0 mb-3"/>
                <PurchaseRequisitionItemDataTable
                    data={group.items}
                    selectionMode="single"
                    paginator={true}
                    rows={20}
                    onDataSelect={this.onDataSelect}
                    delete={this.areItemsEditable() ? this.showRemoveItemConfirm : undefined}
                    fields={this.getItemListFields()}
                    inlineEditEnabled={this.areItemsEditable() && (this.isReturnNote() || this.isDeliveryNote())}
                    onInlineFieldChange={this.onInlineItemFieldChange}
                    reasonOptions={this.isReturnNote() ? RETURN_REASON_CODE : DELIVERY_WASTE_REASON_CODE}
                />
            </div>
            );
        });
    }

    render() {
        if (GeneralUtils.isMobile()) {
            return null;
        }

        if (!this.state.hasInvoiceLicense) {
            return null;
        }

        const editable = this.isEditable();
        const isDelivery = this.isDeliveryNote();
        const isReturn = this.isReturnNote();
        const isPurchaseOrder = this.isPurchaseOrder();
        const isDeliveryOrReturn = isDelivery || isReturn;
        const {docTitle, docNoLabel} = getRequisitionDocLabels(
            this.state.requisition?.requisitionStatus,
            {forDetailPage: true}
        );
        const approveMessage = isReturn
            ? 'Are you sure to approve? Return Note will be locked (Closed).'
            : 'Are you sure to approve? Delivery Note will be locked (Closed).';

        return (
            <div className="settings-page settings-page--full col-md-12">
                <AvForm autocomplete="off" onSubmit={(e) => e.preventDefault()}>
                    <div className="settings-page__shell">
                        <ModalConfirm
                            header="Warning"
                            ok="OK"
                            onOkClick={this.deleteRequisition}
                            onCancelClick={() => this.setState({displayDeleteConfirmDialog: false})}
                            show={this.state.displayDeleteConfirmDialog}
                            message="Are you sure to delete?"
                        />
                        <ModalConfirm
                            header="Warning"
                            ok="OK"
                            onOkClick={this.confirmRemoveItem}
                            onCancelClick={() => this.setState({displayRemoveItemConfirmDialog: false, itemToRemove: null})}
                            show={this.state.displayRemoveItemConfirmDialog}
                            message="Are you sure to remove item?"
                        />
                        <ModalConfirm
                            header="Warning"
                            ok="OK"
                            onOkClick={this.state.checkoutDialogMode === 'returnApprove'
                                ? this.executeReturnApprove
                                : this.executeCheckout}
                            onCancelClick={() => this.setState({displayCheckoutConfirmDialog: false})}
                            show={this.state.displayCheckoutConfirmDialog}
                            message={this.state.checkoutDialogMode === 'returnApprove'
                                ? 'Are you sure to approve? Return Note will be locked (Closed) and selected emails/printouts will be processed.'
                                : 'Are you sure to checkout? Status will be updated to Purchase Order.'}
                        />
                        {isReturn ? (
                            <ModalConfirm
                                header="Warning"
                                ok="OK"
                                onOkClick={() => this.executeApprove(false)}
                                onCancelClick={this.closeApproveConfirmDialog}
                                show={this.state.displayApproveConfirmDialog}
                                message={approveMessage}
                            />
                        ) : (
                            this.renderApproveConfirmDialog()
                        )}

                        <div className="settings-page__header settings-page__header--with-shortcuts">
                            <h1 className="settings-page__title">{docTitle}</h1>
                            <PurchaseRequisitionNavShortcuts
                                activeId={shortcutIdForRequisitionStatus(this.state.requisition?.requisitionStatus)}
                            />
                        </div>

                        <div className="settings-page__panel purchase-requisition-save__header-panel">
                            <FormSection className="purchase-requisition-save__header-section">
                                <Row className="purchase-requisition-save__header-row">
                                    {isDeliveryOrReturn ? (
                                        <>
                                            <Col md="7" className="purchase-requisition-save__header-main">
                                                <Row className="purchase-requisition-save__header-fields">
                                                    <Col md={isDelivery ? '3' : '4'}>
                                                        <AvGroup>
                                                            <Label for="requisitionNo">{docNoLabel}</Label>
                                                            <AvField
                                                                type="text"
                                                                name="requisitionNo"
                                                                disabled={true}
                                                                className="purchase-requisition-save__status-input"
                                                                value={this.state.requisition.requisitionNo || ''}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                    {isDelivery &&
                                                        <Col md="3">
                                                            <AvGroup>
                                                                <Label for="supplierName">
                                                                    Supplier
                                                                    <span style={{color: 'red'}}> *</span>
                                                                </Label>
                                                                <div style={{position: 'relative'}}>
                                                                    <input
                                                                        id="supplierName"
                                                                        type="text"
                                                                        name="supplierName"
                                                                        className="form-control purchase-requisition-save__status-input"
                                                                        style={{paddingRight: editable ? '52px' : undefined}}
                                                                        disabled
                                                                        readOnly
                                                                        value={this.state.requisition.supplierName || ''}
                                                                    />
                                                                    {editable &&
                                                                        <div
                                                                            style={{
                                                                                position: 'absolute',
                                                                                right: '6px',
                                                                                top: '50%',
                                                                                transform: 'translateY(-50%)',
                                                                                display: 'flex',
                                                                                gap: '6px',
                                                                                alignItems: 'center'
                                                                            }}
                                                                        >
                                                                            {!GeneralUtils.isNullOrEmpty(this.state.requisition.supplierId) &&
                                                                                <i
                                                                                    className="pi pi-times"
                                                                                    role="button"
                                                                                    tabIndex={0}
                                                                                    title="Clear supplier"
                                                                                    style={{cursor: 'pointer'}}
                                                                                    onClick={this.clearDeliverySupplier}
                                                                                />
                                                                            }
                                                                            <i
                                                                                className="pi pi-search"
                                                                                role="button"
                                                                                tabIndex={0}
                                                                                title="Search supplier"
                                                                                style={{cursor: 'pointer'}}
                                                                                onClick={this.openDeliverySupplierDialog}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </AvGroup>
                                                        </Col>
                                                    }
                                                    <Col md={isDelivery ? '3' : '4'}>
                                                        <AvGroup>
                                                            <Label for="createDate">
                                                                <Translate contentKey="merchantBranch.updateDate">Create Date</Translate>
                                                            </Label>
                                                            <AvField
                                                                type="text"
                                                                name="createDate"
                                                                disabled={true}
                                                                className="purchase-requisition-save__create-date-input"
                                                                value={this.state.requisition.createDate || ''}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                    <Col md={isDelivery ? '3' : '4'}>
                                                        <AvGroup>
                                                            <Label for="requisitionStatus">Status</Label>
                                                            <AvField
                                                                type="text"
                                                                name="requisitionStatus"
                                                                disabled={true}
                                                                className="purchase-requisition-save__status-input"
                                                                value={this.getRequisitionStatusLabel(this.state.requisition.requisitionStatus)}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                </Row>
                                                <Row className="purchase-requisition-save__header-fields purchase-requisition-save__header-fields--description">
                                                    <Col md="12">
                                                        <AvGroup className="purchase-requisition-save__description-group">
                                                            <Label for="description">Description</Label>
                                                            <AvField
                                                                type="text"
                                                                name="description"
                                                                disabled={!editable}
                                                                value={this.state.requisition.description || ''}
                                                                onChange={this.__handleChange}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md="5" className="purchase-requisition-save__header-po">
                                                {this.renderAssignedPurchaseOrderCard()}
                                            </Col>
                                        </>
                                    ) : isPurchaseOrder ? (
                                        <>
                                            <Col md="7" className="purchase-requisition-save__header-main">
                                                <Row className="purchase-requisition-save__header-fields">
                                                    <Col md="3">
                                                        <AvGroup>
                                                            <Label for="requisitionNo">{docNoLabel}</Label>
                                                            <AvField
                                                                type="text"
                                                                name="requisitionNo"
                                                                disabled={true}
                                                                className="purchase-requisition-save__status-input"
                                                                value={this.state.requisition.requisitionNo || ''}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <AvGroup>
                                                            <Label for="createDate">
                                                                <Translate contentKey="merchantBranch.updateDate">Create Date</Translate>
                                                            </Label>
                                                            <AvField
                                                                type="text"
                                                                name="createDate"
                                                                disabled={true}
                                                                className="purchase-requisition-save__create-date-input"
                                                                value={this.state.requisition.createDate || ''}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <AvGroup>
                                                            <Label for="requisitionStatus">Status</Label>
                                                            <AvField
                                                                type="text"
                                                                name="requisitionStatus"
                                                                disabled={true}
                                                                className="purchase-requisition-save__status-input"
                                                                value={this.getRequisitionStatusLabel(this.state.requisition.requisitionStatus)}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                    <Col md="3">
                                                        <AvGroup>
                                                            <Label for="checkoutDate">Checkout Date</Label>
                                                            <AvField
                                                                type="text"
                                                                name="checkoutDate"
                                                                disabled={true}
                                                                className="purchase-requisition-save__status-input"
                                                                value={this.state.requisition.checkoutDate || ''}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                </Row>
                                                <Row className="purchase-requisition-save__header-fields purchase-requisition-save__header-fields--description">
                                                    <Col md="12">
                                                        <AvGroup className="purchase-requisition-save__description-group">
                                                            <Label for="description">Description</Label>
                                                            <AvField
                                                                type="text"
                                                                name="description"
                                                                disabled={!editable}
                                                                value={this.state.requisition.description || ''}
                                                                onChange={this.__handleChange}
                                                            />
                                                        </AvGroup>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col md="5" className="purchase-requisition-save__header-po">
                                                {this.renderAssignedPurchaseOrderCard()}
                                            </Col>
                                        </>
                                    ) : (
                                        <>
                                            <Col md="2" className="purchase-requisition-save__create-date-col">
                                                <AvGroup>
                                                    <Label for="requisitionNo">{docNoLabel}</Label>
                                                    <AvField
                                                        type="text"
                                                        name="requisitionNo"
                                                        disabled={true}
                                                        className="purchase-requisition-save__status-input"
                                                        value={this.state.requisition.requisitionNo || ''}
                                                    />
                                                </AvGroup>
                                            </Col>
                                            <Col md="2">
                                                <AvGroup>
                                                    <Label for="createDate">
                                                        <Translate contentKey="merchantBranch.updateDate">Create Date</Translate>
                                                    </Label>
                                                    <AvField
                                                        type="text"
                                                        name="createDate"
                                                        disabled={true}
                                                        className="purchase-requisition-save__create-date-input"
                                                        value={this.state.requisition.createDate || ''}
                                                    />
                                                </AvGroup>
                                            </Col>
                                            <Col md="2">
                                                <AvGroup>
                                                    <Label for="requisitionStatus">Status</Label>
                                                    <AvField
                                                        type="text"
                                                        name="requisitionStatus"
                                                        disabled={true}
                                                        className="purchase-requisition-save__status-input"
                                                        value={this.getRequisitionStatusLabel(this.state.requisition.requisitionStatus)}
                                                    />
                                                </AvGroup>
                                            </Col>
                                            <Col md="2">
                                                <AvGroup>
                                                    <Label for="checkoutDate">Checkout Date</Label>
                                                    <AvField
                                                        type="text"
                                                        name="checkoutDate"
                                                        disabled={true}
                                                        className="purchase-requisition-save__status-input"
                                                        value={this.state.requisition.checkoutDate || ''}
                                                    />
                                                </AvGroup>
                                            </Col>
                                            <Col md="2">
                                                <AvGroup>
                                                    <Label for="description">Description</Label>
                                                    <AvField
                                                        type="text"
                                                        name="description"
                                                        disabled={!editable}
                                                        value={this.state.requisition.description || ''}
                                                        onChange={this.__handleChange}
                                                    />
                                                </AvGroup>
                                            </Col>
                                        </>
                                    )}
                                </Row>
                            </FormSection>
                        </div>

                        <div className="settings-page__panel">
                            {this.renderItemListToolbar()}
                            {this.renderItemList()}
                            <div
                                className="settings-page__actions settings-page__actions--dialog-footer settings-page__actions--equal-height"
                            >
                                <div className="settings-page__actions-group">
                                    {editable && !isDeliveryOrReturn &&
                                        <Button
                                            color="outline-primary"
                                            className="settings-page__btn--save"
                                            onClick={this.openCheckoutDialog}
                                            disabled={!this.hasSavedRequisition()}
                                        >
                                            Checkout
                                        </Button>
                                    }
                                    {editable && isDeliveryOrReturn &&
                                        <Button
                                            color="outline-primary"
                                            className="settings-page__btn--save"
                                            onClick={this.openApproveDialog}
                                            disabled={!this.hasSavedRequisition()}
                                        >
                                            Approve
                                        </Button>
                                    }
                                    {editable &&
                                        <Button
                                            color="outline-primary"
                                            className="settings-page__btn--save"
                                            onClick={this.saveRequisition}
                                        >
                                            <Translate contentKey="entity.action.add">Save</Translate>
                                        </Button>
                                    }
                                    <Button
                                        color="outline-primary"
                                        className="settings-page__btn--cancel settings-page__btn--back"
                                        onClick={this.goBackToList}
                                    >
                                        <i className="pi pi-arrow-left" aria-hidden="true"/>
                                        <Translate contentKey="entity.action.cancel">Back</Translate>
                                    </Button>
                                </div>
                                {this.hasSavedRequisition() && !this.isApproved() &&
                                    <div className="settings-page__actions-group settings-page__actions-group--end">
                                        <Button
                                            color="outline-danger"
                                            className="settings-page__btn--delete"
                                            onClick={this.showDeleteConfirmDialog}
                                        >
                                            <Translate contentKey="entity.action.delete">Delete</Translate>
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                        <Dialog
                        visible={this.state.displayDialog}
                        header={editable && !this.areReturnItemsLockedFromDn() ? 'Product' : 'Product (View)'}
                        onHide={this.closeItemDialog}
                        style={GeneralUtils.getDialogStyleForPurchaseRequisitionItem()}
                    >
                        <PurchaseRequisitionItemMobileSave
                            webPopup={true}
                            readOnly={!editable || this.areReturnItemsLockedFromDn()}
                            deliveryMode={isDelivery}
                            returnMode={isReturn}
                            showCostAlternatives={editable && !isDeliveryOrReturn && !this.areReturnItemsLockedFromDn()}
                            documentSupplierId={isDelivery ? this.state.requisition.supplierId : null}
                            documentSupplierName={isDelivery ? this.state.requisition.supplierName : null}
                            documentSupplierBssId={isDelivery ? this.state.requisition.supplierBssId : null}
                            ref={(elem) => this.refModelSave = elem}
                            saveItem={this.saveItem}
                            saveItemAndNext={this.saveItemAndNext}
                            closeItemDialog={this.closeItemDialog}
                        />
                    </Dialog>
                    {this.renderCheckoutDialog()}
                    {this.renderDeliverySupplierDialog()}
                    {this.renderAssignPurchaseOrderDialog()}
                    {this.renderAssignDeliveryNoteDialog()}
                </AvForm>
                {this.state.loading && <Loading/>}
            </div>
        );
    }
}
